import i18n from "i18next";
import Languages from "pages/config/Languages";
import { initReactI18next } from "react-i18next";

const languagesConfig = {};

for (let code in Languages) {
  languagesConfig[code] = {
    translation: require("./" + code + ".json"),
  };
}

i18n.use(initReactI18next).init({
  resources: languagesConfig,
  lng: Object.keys(Languages)[0],
  fallbackLng: Object.keys(Languages)[0],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
